import {
  Fish,
  IdCard,
  Landmark,
  MessageCircle,
  Palette,
  Scale,
  ShieldAlert,
  UserRound,
  UsersRound,
} from "lucide-react";

export function ReportingIcon({
  label,
  size = 20,
}: {
  label: string;
  size?: number;
}) {
  const Icon = /phish/i.test(label)
    ? Fish
    : /journal|media/i.test(label)
      ? IdCard
      : /human.right|lawyer/i.test(label)
        ? Scale
        : /women|society|organization/i.test(label)
          ? UsersRound
          : /artist/i.test(label)
            ? Palette
            : /harass|message|spam/i.test(label)
              ? MessageCircle
              : /activist|protest/i.test(label)
                ? Landmark
                : /compromise|malware|attack|credential/i.test(label)
                  ? ShieldAlert
                  : UserRound;
  return <Icon size={size} strokeWidth={1.6} aria-hidden="true" />;
}
